// extracted by mini-css-extract-plugin
export default {"skeleton-list":"vxsaJ","skeleton-item":"sU0mO","column-4":"i0K8c","column-3":"Vv1nf","column-5":"GYgUV"};